import { Component, ChangeDetectorRef, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';

import {
  Router,
  // import as RouterEvent to avoid confusion with the DOM Event
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router'

import {
  transition,
  trigger,
  query,
  style,
  animate,
  group,
  animateChild
} from '@angular/animations';
import { AppService } from './app.service';
import { environment } from "../environments/environment";

declare var $;
declare var gtag;
declare var fbq;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    trigger('myAnimation', [
      transition('* => *', [
        query(
          ':enter',
          [style({ opacity: 0 })],
          { optional: true }
        ),
        query(
          ':leave',
          [style({ opacity: 1 }), animate('0.3s', style({ opacity: 0 }))],
          { optional: true }
        ),
        query(
          ':enter',
          [style({ opacity: 0 }), animate('0.3s', style({ opacity: 1 }))],
          { optional: true }
        )
      ])
    ]),
  ] // register the animations
})
export class AppComponent {
  title = 'Propira';
  loader: boolean = false;
  display: boolean = true;
  constructor(
    @Inject(DOCUMENT) private dom,
    public router: Router, private service: AppService, private cdr: ChangeDetectorRef, @Inject(PLATFORM_ID) private platformId: Object) {
    if (!isPlatformBrowser(this.platformId)) {
      this.display = false;
    }

    this.router.events.subscribe((routerEvent: RouterEvent) => { 
      if (routerEvent instanceof NavigationStart) {
        this.service.loaderStatus = true;
        this.cdr.detectChanges();
        this.loader = true;

        if (isPlatformBrowser(this.platformId)) {
          $('#loginModal').modal('hide');
        }
      }

      if (routerEvent instanceof NavigationEnd ||
        routerEvent instanceof NavigationCancel ||
        routerEvent instanceof NavigationError) {
        this.service.loaderStatus = false;
        this.cdr.detectChanges();
        this.loader = true;

        this.createCanonicalURL(this.service.websiteUrl + this.router.url);

        if (this.router.url == '/404') {
          this.service.setMetaTags({ name: "robots", content: 'noindex,nofollow' });
        } else {
          this.service.setMetaTags({ name: "robots", content: 'index,follow' });
        }
      }

      this.service.setMetaTags({ property: "og:url", content: this.service.websiteUrl + this.router.url });

      if (routerEvent instanceof NavigationEnd && isPlatformBrowser(this.platformId)) {
        //set google analytics
        if (environment.production) {
          gtag('config', environment.gtagId, {
            'page_path': this.service.websiteUrl+routerEvent.url
          });
          fbq('init', environment.fbId, {
            'track': this.service.websiteUrl+routerEvent.url
          });
          fbq('track', 'PageView');
        }
      }
    });

  }

  get chkProgressBar() {
    return this.service.loaderStatus;
  }

  createCanonicalURL(url) {
    let links = this.dom.getElementsByTagName("link");
    links[1].setAttribute('href', url);
  }
}

